import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-help-popover',
  template: `
    <ion-content class="help-popover-content">
      <div class="help-header">
        <ion-icon name="information-circle" class="help-header-icon"></ion-icon>
        <span class="help-title">{{ translationObject['Hilfe'] }}</span>
        <ion-button fill="clear" size="small" (click)="closePopover()" class="close-button">
          <ion-icon name="close" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
      
      <div class="help-content">
        <p>{{ getHelpText() }}</p>
        
        <div *ngIf="hasDetailedHelp()" class="help-actions">
          <ion-button fill="outline" size="small" (click)="showDetailedHelp()">
            {{ translationObject['MehrErfahren'] }}
          </ion-button>
        </div>
      </div>
    </ion-content>
  `,
  styleUrls: ['./help-popover.component.scss']
})
export class HelpPopoverComponent implements OnInit {
  @Input() helpKey: string = '';
  @Input() translationObject: any = {};



  constructor(private popoverController: PopoverController) {}

  ngOnInit() {}

  getHelpText(): string {
    const helpKey = `Help${this.helpKey.charAt(0).toUpperCase() + this.helpKey.slice(1)}`;
    return this.translationObject[helpKey] || this.translationObject['HilfeNichtVerfügbar'] || 'Hilfe für diesen Bereich ist nicht verfügbar.';
  }

  hasDetailedHelp(): boolean {
    return false;
  }

  showDetailedHelp() {
    console.log('Show detailed help for:', this.helpKey);
  }

  closePopover() {
    this.popoverController.dismiss();
  }

  private getCurrentLanguage(): string {
    if (this.translationObject['Dashboard'] === 'Dashboard' && 
        this.translationObject['Hilfe'] === 'Help') {
      return 'en';
    }
    return 'de';
  }
}
